var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotion-card"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.iconUrl,"alt":"promotion card icon"}}),_c('PurpurParagraph',{staticClass:"promotion-card__paragraph"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }